// function syncAutocompletePosition() {
//   if (window.innerWidth < 768) return;

//   const searchBar = document.querySelector(
//       ".wz-search-box .wz-search-input"
//   );

//   const autoComplete = document.querySelector(
//       ".wizzy-autocomplete-wrapper"
//   );

//   if (!searchBar || !autoComplete) return;

//   const rect = searchBar.getBoundingClientRect();
//   const rightOffset = window.innerWidth - rect.right;

//   autoComplete.style.setProperty(
//       "right",
//       `${rightOffset}px`,
//       "important"
//   );

//   autoComplete.style.setProperty(
//       "left",
//       "auto",
//       "important"
//   );
// }


// document.addEventListener("click", function (event) {
//   if (
//       window.innerWidth >= 768 &&
//       event.target.matches(".wz-search-box .wz-search-input")
//   ) {
//       requestAnimationFrame(function () {
//           requestAnimationFrame(syncAutocompletePosition);
//       });
//   }
// });


// // document.addEventListener("focusin", function (event) {
// //     if (
// //         window.innerWidth >= 768 &&
// //         event.target.matches(".wz-search-box .wz-search-input")
// //     ) {
// //         requestAnimationFrame(function () {
// //             requestAnimationFrame(syncAutocompletePosition);
// //         });
// //     }
// // });
// window.onWizzyScriptLoaded = function () {

// // Optional fallback only. Prefer Shopify/Wizzy `data.swatch` from the API.
// // Override/extend without editing logic:
// //   window.wizzyColorSwatchConfig = { "New Color": "#aabbcc" };
// var DEFAULT_COLOR_SWATCH_CONFIG = {
//   Green: "#008000",
//   Silver: "#C0C0C0",
//   Red: "#FF0000",
//   Gold: "#D4AF37",
//   Pink: "#FFC0CB",
//   Blue: "#0000FF",
//   "Mint Green": "#98FF98",
//   MintGreen: "#98FF98",
//   Mint: "#98FF98",
//   White: "#FFFFFF",
//   white: "#FFFFFF",
//   Purple: "#800080",
//   "Rose Gold": "#B76E79",
//   Yellow: "#FFD700",
//   Ruby: "#E0115F",
//   "Dark Pink": "#C71585",
//   "Light Pink": "#FFB6C1",
//   "Baby Pink": "#F4C2C2",
//   Orange: "#FFA500",
//   "Dark Green": "#006400",
//   Black: "#000000",
//   Champagne: "#F7E7CE",
//   Brown: "#8B4513",
//   Cyan: "#00FFFF",
//   "Deep Red": "#8B0000",
//   Fluoride: "#C8F7E8",
//   Grey: "#808080",
//   Gray: "#808080",
//   Pearl: "#F0EAD6",
//   Lavender: "#E6E6FA",
//   Peach: "#FFCBA4",
//   Multicolor:
//     "linear-gradient(90deg, #FF0000, #FFA500, #FFD700, #008000, #0000FF, #800080)",
//   "Multi-color":
//     "linear-gradient(90deg, #FF0000, #FFA500, #FFD700, #008000, #0000FF, #800080)",
//   Multi:
//     "linear-gradient(90deg, #FF0000, #FFA500, #FFD700, #008000, #0000FF, #800080)",
//   Navratna:
//     "linear-gradient(90deg, #E0115F, #FFFFFF, #FF0000, #008000, #FFD700, #0000FF, #FF8C00, #800080, #FFC0CB)",
//   "Red & Green": "linear-gradient(90deg, #FF0000 50%, #008000 50%)",
//   "Green & Red": "linear-gradient(90deg, #008000 50%, #FF0000 50%)",
//   "Mint & Pink": "linear-gradient(90deg, #98FF98 50%, #FFC0CB 50%)",
//   "Pink & Purple": "linear-gradient(90deg, #FFC0CB 50%, #800080 50%)",
//   "Mint & Purple": "linear-gradient(90deg, #98FF98 50%, #800080 50%)",
//   "Purple & Green": "linear-gradient(90deg, #800080 50%, #008000 50%)",
//   "Purple & Pink": "linear-gradient(90deg, #800080 50%, #FFC0CB 50%)",
//   "Green & Mint Green": "linear-gradient(90deg, #008000 50%, #98FF98 50%)",
//   "Green & Purple": "linear-gradient(90deg, #008000 50%, #800080 50%)",
//   "Green Blue": "linear-gradient(90deg, #008000 50%, #0000FF 50%)",
//   "Purple & Mint": "linear-gradient(90deg, #800080 50%, #98FF98 50%)",
//   "Blue Purple": "linear-gradient(90deg, #0000FF 50%, #800080 50%)",
//   "Blue-Green": "linear-gradient(90deg, #0000FF 50%, #008000 50%)",
//   "Blue-Pink": "linear-gradient(90deg, #0000FF 50%, #FFC0CB 50%)",
//   "Dual Polish": "linear-gradient(90deg, #D4AF37 50%, #C0C0C0 50%)",
//   "Fluorite-Mint": "linear-gradient(90deg, #A7C7E7 50%, #98FF98 50%)"
// };

// var colorMap = Object.assign(
//   {},
//   DEFAULT_COLOR_SWATCH_CONFIG,
//   window.wizzyColorSwatchConfig || {}
// );

// // label(lower) → resolved paint value for post-render gradient fixes
// var resolvedFacetSwatches = {};

// function handleize(value) {
//   return String(value || "")
//     .toLowerCase()
//     .trim()
//     .replace(/['"]/g, "")
//     .replace(/[^a-z0-9]+/g, "-")
//     .replace(/^-+|-+$/g, "");
// }

// function getProductHandle(product) {
//   if (product.handle) return product.handle;

//   if (product.attributes && Array.isArray(product.attributes)) {
//     for (var i = 0; i < product.attributes.length; i++) {
//       var attr = product.attributes[i];
//       if (
//         attr.id === "product_handle" &&
//         attr.values &&
//         attr.values.length &&
//         attr.values[0].value
//       ) {
//         return attr.values[0].value[0];
//       }
//     }
//   }

//   if (product.url) {
//     var match = String(product.url).match(/\/products\/([^/?#]+)/);
//     if (match) return match[1];
//   }

//   return "";
// }

// function getColorSwatchItems(product) {
//   var swatches = product.swatches;
//   if (!swatches) return [];

//   if (Array.isArray(swatches)) {
//     for (var i = 0; i < swatches.length; i++) {
//       var group = swatches[i];
//       if (!group || !Array.isArray(group.values)) continue;
//       var key = String(group.key || "").toLowerCase();
//       if (
//         key === "colors" ||
//         key === "color" ||
//         key === "colours" ||
//         key === "colour" ||
//         group.isPrimary
//       ) {
//         return group.values;
//       }
//     }
//     if (swatches[0] && Array.isArray(swatches[0].values)) {
//       return swatches[0].values;
//     }
//     return [];
//   }

//   if (swatches.colors && Array.isArray(swatches.colors.values)) {
//     return swatches.colors.values;
//   }

//   return [];
// }

// function getSwatchLabel(item) {
//   if (!item) return "";
//   if (item.label) return String(item.label);
//   var value = item.value;
//   if (Array.isArray(value)) return String(value[0] || "");
//   return String(value || "");
// }

// function getApiSwatchValue(item) {
//   if (!item) return "";

//   if (
//     item.data &&
//     item.data.swatch &&
//     item.data.swatch.value != null &&
//     String(item.data.swatch.value).trim() !== ""
//   ) {
//     return String(item.data.swatch.value).trim();
//   }

//   if (item.swatchValue != null && String(item.swatchValue).trim() !== "") {
//     return String(item.swatchValue).trim();
//   }

//   if (item.swatch && item.swatch.value != null) {
//     return String(item.swatch.value).trim();
//   }

//   // Product card swatch values sometimes carry a direct color/hex field
//   if (item.color != null && String(item.color).trim() !== "") {
//     return String(item.color).trim();
//   }

//   return "";
// }

// function isImageSwatchUrl(value) {
//   if (!value) return false;
//   if (/^https?:\/\//i.test(value)) return true;
//   if (/^\/\//.test(value)) return true;
//   return /\.(png|jpe?g|webp|gif|svg)(\?.*)?$/i.test(value);
// }

// function isUsableSwatchValue(value) {
//   if (!value) return false;
//   if (/gradient/i.test(value)) return true;
//   if (isImageSwatchUrl(value)) return true;
//   if (/^#([0-9a-f]{3}|[0-9a-f]{6}|[0-9a-f]{8})$/i.test(value)) return true;
//   if (/^rgba?\(/i.test(value)) return true;
//   if (/^hsla?\(/i.test(value)) return true;
//   return false;
// }

// function findConfigColorValue(label) {
//   if (!label) return "";
//   if (colorMap[label]) return colorMap[label];

//   var keys = Object.keys(colorMap);
//   var lower = String(label).toLowerCase();
//   for (var i = 0; i < keys.length; i++) {
//     if (keys[i].toLowerCase() === lower) return colorMap[keys[i]];
//   }
//   return "";
// }

// /**
//  * Resolve paint value for a facet/card color.
//  * Priority: API data.swatch → optional config → grey
//  */
// function resolveSwatchPaint(itemOrLabel, maybeLabel) {
//   var item = typeof itemOrLabel === "object" ? itemOrLabel : null;
//   var label =
//     maybeLabel ||
//     (item ? item.key || item.label || getSwatchLabel(item) : itemOrLabel) ||
//     "";

//   var apiValue = getApiSwatchValue(item);
//   if (isUsableSwatchValue(apiValue)) {
//     return {
//       value: apiValue,
//       source: "api",
//       isURLSwatch: isImageSwatchUrl(apiValue) && !/gradient/i.test(apiValue)
//     };
//   }

//   var configValue = findConfigColorValue(label);
//   if (isUsableSwatchValue(configValue)) {
//     return {
//       value: configValue,
//       source: "config",
//       isURLSwatch:
//         isImageSwatchUrl(configValue) && !/gradient/i.test(configValue)
//     };
//   }

//   return {
//     value: "#e5e5e5",
//     source: "fallback",
//     isURLSwatch: false
//   };
// }

// function findColorValue(label) {
//   var resolved = resolveSwatchPaint(null, label);
//   return resolved.source === "fallback" ? "" : resolved.value;
// }

// function buildSwatchStyleFromValue(color) {
//   if (!color) return "background-color:#e5e5e5;";
//   if (/gradient/i.test(color)) {
//     return "background-image:" + color + ";";
//   }
//   if (isImageSwatchUrl(color)) {
//     var url = color.indexOf("//") === 0 ? "https:" + color : color;
//     return "background-image:url(" + url + ");background-size:cover;";
//   }
//   return "background-color:" + color + ";";
// }

// function buildSwatchStyle(label, item) {
//   var resolved = resolveSwatchPaint(item || null, label);
//   return buildSwatchStyleFromValue(resolved.value);
// }

// function buildCardSwatches(product) {
//   var handle = product.handle;
//   var items = getColorSwatchItems(product);
//   var seen = {};
//   var cardSwatches = [];

//   items.forEach(function (item) {
//     if (!item) return;
//     var label = getSwatchLabel(item).trim();
//     var variationId = item.variationId;
//     if (!label || !variationId) return;

//     var uniqueKey = label.toLowerCase();
//     if (seen[uniqueKey]) return;
//     seen[uniqueKey] = true;

//     cardSwatches.push({
//       label: label,
//       handle: handleize(label),
//       variationId: String(variationId),
//       href: handle
//         ? "/products/" + handle + "?variant=" + variationId
//         : "?variant=" + variationId,
//       swatchStyle: buildSwatchStyle(label, item)
//     });
//   });

//   product.cardSwatches = cardSwatches;
//   product.hasCardSwatches = cardSwatches.length >= 2;
// }

// var variantImageCache = {};

// function normalizeImageUrl(src) {
//   if (!src) return "";
//   if (src.indexOf("//") === 0) return "https:" + src;
//   return src;
// }

// function getVariantImageMap(handle) {
//   if (!handle) return Promise.resolve({});
//   if (variantImageCache[handle]) return variantImageCache[handle];

//   variantImageCache[handle] = fetch("/products/" + encodeURIComponent(handle) + ".js")
//     .then(function (response) {
//       if (!response.ok) throw new Error("product json failed");
//       return response.json();
//     })
//     .then(function (data) {
//       var map = {};
//       var fallback = normalizeImageUrl(data.featured_image || "");
//       (data.variants || []).forEach(function (variant) {
//         var src = "";
//         if (variant.featured_image) {
//           src = variant.featured_image.src || variant.featured_image;
//         }
//         src = normalizeImageUrl(src) || fallback;
//         if (src) map[String(variant.id)] = src;
//       });
//       return map;
//     })
//     .catch(function () {
//       delete variantImageCache[handle];
//       return {};
//     });

//   return variantImageCache[handle];
// }

// function bindSwatchHover() {
//   document.querySelectorAll(".wizzy-result-product").forEach(function (card) {
//     if (card.dataset.wizzySwatchHoverBound === "true") return;

//     var swatches = card.querySelectorAll(".grid-product__colors .color-swatch");
//     if (!swatches.length) return;

//     var handle = card.getAttribute("data-product-handle") || "";
//     var preview = card.querySelector(".wizzy-swatch-preview");
//     if (!handle || !preview) return;

//     card.dataset.wizzySwatchHoverBound = "true";
//     getVariantImageMap(handle);

//     var hoveredId = null;

//     function showPreview(swatch) {
//       var variantId = swatch.getAttribute("data-variant-id");
//       hoveredId = variantId;
//       getVariantImageMap(handle).then(function (map) {
//         if (hoveredId !== variantId) return;
//         var url = map[variantId];
//         if (!url) return;
//         preview.style.backgroundImage = "url(" + url + ")";
//         preview.classList.add("is-active");
//         swatch.classList.add("is-active");
//       });
//     }

//     function hidePreview(swatch) {
//       hoveredId = null;
//       preview.classList.remove("is-active");
//       swatch.classList.remove("is-active");
//     }

//     swatches.forEach(function (swatch) {
//       swatch.addEventListener("mouseenter", function () {
//         showPreview(swatch);
//       });
//       swatch.addEventListener("mouseleave", function () {
//         hidePreview(swatch);
//       });
//     });
//   });
// }

// function bindImpulseQuickShop() {
//   if (!window.theme || typeof theme.preloadProductModal !== "function") {
//     return;
//   }

//   document.querySelectorAll(".wizzy-result-product").forEach(function (card) {
//     if (card.dataset.wizzyQuickShopBound === "true") return;
//     card.dataset.wizzyQuickShopBound = "true";

//     var handle =
//       card.getAttribute("data-product-handle") ||
//       card.getAttribute("handle") ||
//       "";
//     var productId = card.getAttribute("data-product-id") || "";
//     var btn = card.querySelector(".quick-product__btn");

//     if (!handle || !productId || !btn) return;

//     var preloading = false;

//     function isReady() {
//       return !btn.classList.contains("quick-product__btn--not-ready");
//     }

//     function preload() {
//       if (theme.config && theme.config.bpSmall) return;
//       if (preloading || isReady()) return;
//       preloading = true;
//       theme.preloadProductModal(handle, productId, btn);

//       var tries = 0;
//       var timer = setInterval(function () {
//         tries += 1;
//         if (isReady() || tries > 50) {
//           clearInterval(timer);
//           preloading = false;
//         }
//       }, 100);
//     }

//     function productMouseover() {
//       card.removeEventListener("mouseover", productMouseover);
//       card.removeEventListener("focusin", productMouseover);
//       preload();
//     }

//     card.addEventListener("mouseover", productMouseover);
//     card.addEventListener("focusin", productMouseover);

//     // Capture phase so we can cancel <a> navigation; do not stopPropagation when
//     // ready or Impulse's Modals open listener on this same button never runs.
//     btn.addEventListener(
//       "click",
//       function (e) {
//         e.preventDefault();

//         if (theme.config && theme.config.bpSmall) return;

//         // Already preloaded — let Impulse Modals open handler run
//         if (isReady()) return;

//         e.stopPropagation();
//         preload();

//         var tries = 0;
//         var timer = setInterval(function () {
//           tries += 1;
//           if (isReady()) {
//             clearInterval(timer);
//             btn.dispatchEvent(
//               new MouseEvent("click", {
//                 bubbles: true,
//                 cancelable: true,
//                 view: window
//               })
//             );
//           } else if (tries > 50) {
//             clearInterval(timer);
//           }
//         }, 100);
//       },
//       true
//     );
//   });
// }

//   function getAbsoluteProductUrl(product) {
//     var url = String(product.url || "");
//     if (url.indexOf("http://") === 0 || url.indexOf("https://") === 0) {
//       return url;
//     }
//     if (product.handle) url = "/products/" + product.handle;
//     if (!url) return "";
//     if (url.charAt(0) !== "/") url = "/" + url;
//     return window.location.origin + url;
//   }

//   function bindWizzySwymDelegate() {
//     if (document.body.dataset.wizzySwymDelegate === "true") return;
//     document.body.dataset.wizzySwymDelegate = "true";

//     document.addEventListener("click", function (e) {
//       var btn = e.target.closest(".wizzy-result-product button#swym-collections");
//       if (!btn) return;

//       e.preventDefault();
//       e.stopPropagation();

//       var proxy = document.querySelector("[data-wizzy-swym-proxy='true']");
//       if (!proxy) return;

//       proxy.setAttribute("data-product-url", btn.getAttribute("data-product-url") || "");
//       proxy.setAttribute("data-product-id", btn.getAttribute("data-product-id") || "");
//       proxy.setAttribute("data-variant-id", btn.getAttribute("data-variant-id") || "");
//       proxy.click();
//     }, true);
//   }

//   function ensureSwymClickProxy() {
//     if (document.querySelector("[data-wizzy-swym-proxy='true']")) return;
//     if (typeof onSwymLoadCallback !== "function") return;

//     function createProxy(swat) {
//       if (document.querySelector("[data-wizzy-swym-proxy='true']")) return;
//       window._swat = window._swat || swat;
//       if (!window._swat) return;

//       var proxy = document.createElement("button");
//       proxy.id = "swym-collections";
//       proxy.setAttribute("data-wizzy-swym-proxy", "true");
//       proxy.className = "swym-button swym-heart swym-add-to-wishlist-view-product";
//       proxy.style.display = "none";
//       document.body.appendChild(proxy);

//       var closeBtn = document.getElementById("swym-custom-modal-close");
//       var addBtn = document.getElementById("swym-custom-add-to-wishlist-button");
//       if (closeBtn && closeBtn.parentNode) {
//         closeBtn.parentNode.replaceChild(closeBtn.cloneNode(true), closeBtn);
//       }
//       if (addBtn && addBtn.parentNode) {
//         addBtn.parentNode.replaceChild(addBtn.cloneNode(true), addBtn);
//       }

//       onSwymLoadCallback(window._swat);
//     }

//     if (window._swat) {
//       createProxy(window._swat);
//       return;
//     }

//     window.SwymCallbacks = window.SwymCallbacks || [];
//     window.SwymCallbacks.push(createProxy);
//   }

//   function reinitSwymWishlist() {
//     document.querySelectorAll(".wizzy-result-product button#swym-collections").forEach(function (btn) {
//       btn.classList.add("swym-custom-loaded");
//     });
//     bindWizzySwymDelegate();
//     ensureSwymClickProxy();
//   }

//   function moveSearchSummaryAboveProducts() {
//     var summary = document.querySelector(".wizzy-search-summary-container");
//     var sort = document.querySelector(".wizzy-search-sort-wrapper");
//     var filtersTop = document.querySelector(
//       ".wizzy-search-results-container > .wizzy-search-filters-top"
//     );
//     if (!summary || !filtersTop) return;

//     var isDesktop = window.matchMedia("(min-width: 769px)").matches;

//     if (summary.parentElement !== filtersTop) {
//       var valuesWrap = filtersTop.querySelector(".filters-list-top-values-wrapper");
//       if (valuesWrap) filtersTop.insertBefore(summary, valuesWrap);
//       else filtersTop.appendChild(summary);
//     }

//     // Sort sits inside the summary row on desktop only
//     if (isDesktop && sort && sort.parentElement !== summary) {
//       summary.appendChild(sort);
//     }
//   }

//   function sortOptionIdentity(option) {
//     if (!option) return "";
//     return (
//       String(option.value || "").trim() +
//       "|" +
//       String(option.getAttribute("data-order") || "").trim()
//     );
//   }

//   function configuredDefaultSortIdentity() {
//     var sorts =
//       window.wizzyConfig &&
//       window.wizzyConfig.search &&
//       window.wizzyConfig.search.configs &&
//       window.wizzyConfig.search.configs.sorts &&
//       window.wizzyConfig.search.configs.sorts.configs;
//     if (!sorts) return "";
//     var keys = Object.keys(sorts);
//     if (!keys.length || !sorts[keys[0]] || !sorts[keys[0]].field) return "";
//     return (
//       String(sorts[keys[0]].field).trim() +
//       "|" +
//       String(sorts[keys[0]].order || "").trim()
//     );
//   }

//   function isNonDefaultSort() {
//     var select = document.querySelector(".wizzy-search-sort-wrapper select");
//     if (!select || select.selectedIndex < 0 || !select.options.length) return false;

//     var option = select.options[select.selectedIndex];
//     if (!option) return false;

//     var current = sortOptionIdentity(option);
//     var configured = configuredDefaultSortIdentity();
//     if (configured) {
//       for (var i = 0; i < select.options.length; i++) {
//         if (sortOptionIdentity(select.options[i]) === configured) {
//           return current !== configured;
//         }
//       }
//     }

//     var text = String(option.text || "").trim().toLowerCase();
//     if (!text || text === "sort by" || text.indexOf("relevant") !== -1) return false;
//     return current !== sortOptionIdentity(select.options[0]);
//   }

//   function appliedFilterCount() {
//     if (!document.querySelector(".wizzy-filters-header .wizzy-filters-clear-all")) {
//       return 0;
//     }

//     var items = document.querySelectorAll(
//       ".wizzy-selected-filters .wizzy-selected-facet-list-item"
//     );
//     var count = 0;
//     items.forEach(function (item) {
//       if (!item.getAttribute("data-key")) return;
//       count += 1;
//     });
//     return count || items.length;
//   }

//   function setAppliedDot(host, on) {
//     if (!host) return;
//     var existing = host.querySelector(":scope > .wz-applied-dot");
//     if (!on) {
//       if (existing) existing.remove();
//       return;
//     }
//     if (existing) return;
//     var dot = document.createElement("span");
//     dot.className = "wz-applied-dot";
//     dot.setAttribute("aria-hidden", "true");
//     host.appendChild(dot);
//   }

//   function syncMobileFilterSortIndicators() {
//     var count = appliedFilterCount();
//     var filtersOn = count > 0;
//     var sortOn = isNonDefaultSort();

//     document.querySelectorAll(".wz-active-filters-mobile-count").forEach(function (el) {
//       el.textContent = filtersOn ? "(" + count + ")" : "";
//     });

//     document.querySelectorAll(".wz-filter-icon > .wz-applied-dot").forEach(function (dot) {
//       dot.remove();
//     });

//     document.querySelectorAll(".wizzy-filters-mobile-entry").forEach(function (btn) {
//       btn.classList.toggle("wz-has-active-filters", filtersOn);
//       setAppliedDot(btn, filtersOn);
//     });

//     document.querySelectorAll(".wizzy-search-sort-wrapper").forEach(function (wrap) {
//       wrap.classList.toggle("wz-has-active-sort", sortOn);
//       setAppliedDot(wrap.querySelector(".wizzy-common-select-label"), sortOn);
//     });
//   }

//   if (!document.documentElement.dataset.wzFilterSortBound) {
//     document.documentElement.dataset.wzFilterSortBound = "1";
//     document.addEventListener("change", function (event) {
//       var target = event.target;
//       if (!target || !target.classList || !target.classList.contains("wizzy-sort-select")) return;
//       syncMobileFilterSortIndicators();
//     });
//   }

//   function afterCardsRendered(data) {
//     moveSearchSummaryAboveProducts();
//     bindSwatchHover();
//     applyGradientFacetSwatches();
//     bindImpulseQuickShop();
//     reinitSwymWishlist();
//     syncMobileFilterSortIndicators();
//     return data;
//   }

// var colorFacetKeys = {
//   colors: true,
//   product_Color: true,
//   product_value_tags_color: true
// };

// function applyColorFacetSwatches(payload) {
//   if (!payload || (payload.api !== "search" && payload.api !== "filter")) {
//     return payload;
//   }

//   var facets =
//     payload.response &&
//     payload.response.payload &&
//     payload.response.payload.facets;
//   if (!facets || !Array.isArray(facets)) return payload;

//   resolvedFacetSwatches = {};

//   facets.forEach(function (facet) {
//     if (!facet || !colorFacetKeys[facet.key] || !Array.isArray(facet.data)) {
//       return;
//     }

//     facet.data.forEach(function (item) {
//       if (!item) return;

//       var label = item.key || item.label || "";
//       var resolved = resolveSwatchPaint(item, label);
//       var color = resolved.value;

//       // Gradients are not URLs — keep solid template path, then fix in
//       // applyGradientFacetSwatches(). Image URLs use isURLSwatch.
//       item.isSwatch = true;
//       item.isVisualSwatch = true;
//       item.isURLSwatch = !!resolved.isURLSwatch;
//       item.swatchValue = color;
//       item.data = {
//         value: item.key,
//         swatch: {
//           type: "visual",
//           value: color
//         }
//       };

//       if (label) {
//         resolvedFacetSwatches[String(label).toLowerCase()] = color;
//       }
//     });
//   });

//   return payload;
// }

// function applySwatchPaint(el, color) {
//   if (!el || !color) return;

//   if (/gradient/i.test(color)) {
//     el.style.backgroundColor = "transparent";
//     el.style.backgroundImage = color;
//     return;
//   }

//   if (isImageSwatchUrl(color)) {
//     var url = color.indexOf("//") === 0 ? "https:" + color : color;
//     el.style.backgroundColor = "transparent";
//     el.style.backgroundImage = "url(" + url + ")";
//     el.style.backgroundSize = "cover";
//     return;
//   }

//   el.style.backgroundImage = "none";
//   el.style.backgroundColor = color;
// }

// function applyGradientFacetSwatches() {
//   var nodes = document.querySelectorAll(
//     ".wizzy-facet-list-item.facet-has-swatch, .wizzy-selected-facet-list-item.facet-has-swatch"
//   );

//   nodes.forEach(function (li) {
//     var label = (
//       li.getAttribute("data-term") ||
//       li.getAttribute("title") ||
//       ""
//     ).trim();
//     if (!label) return;

//     var color =
//       resolvedFacetSwatches[label.toLowerCase()] ||
//       findColorValue(label);
//     if (!color) return;

//     var swatch = li.querySelector(
//       ".wizzy-facet-item-swatch.facet-visual-swatch"
//     );
//     applySwatchPaint(swatch, color);
//   });

//   // Fallback: fix invalid inline styles templates may emit for gradients
//   document.querySelectorAll(".facet-visual-swatch").forEach(function (el) {
//     var styleAttr = el.getAttribute("style") || "";
//     var bgImage = el.style.backgroundImage || "";

//     var colorGradientMatch = styleAttr.match(
//       /background-color\s*:\s*((?:linear|radial)-gradient\([^;]*\))/i
//     );
//     if (colorGradientMatch) {
//       applySwatchPaint(el, colorGradientMatch[1]);
//       return;
//     }

//     if (/url\(\s*['"]?(?:linear|radial)-gradient/i.test(bgImage)) {
//       var unwrapped = bgImage.replace(
//         /^url\(\s*['"]?((?:linear|radial)-gradient[\s\S]*?)['"]?\s*\)$/i,
//         "$1"
//       );
//       if (unwrapped && unwrapped !== bgImage) {
//         applySwatchPaint(el, unwrapped);
//       }
//     }
//   });
// }

// function stripPriceDecimals(value) {
//   if (value === undefined || value === null) return value;
//   var str = String(value);
//   if (str.indexOf(".") === -1) return str;
//   return str.split(".")[0];
// }

// // So liquid can safely append &width=360 for responsive srcset
// function ensureImageWidthJoin(url) {
//   if (!url) return "";
//   var s = String(url);
//   if (s.indexOf("?") === -1) return s + "?";
//   return s;
// }

// window.wizzyConfig.events.registerEvent(
//   window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
//   function (products) {
//     if (!Array.isArray(products)) return products;

//     products.forEach(function (product) {
//         product.displayAddToCart = true;
//         product.handle = getProductHandle(product);
//         // Shopify product id (not variant id) — required for Impulse Quick Shop modal
//         product.shopifyProductId = String(
//           product.groupId || product.singleVarientGroupId || ""
//         );
//         product.wishlistUrl = getAbsoluteProductUrl(product);
//         buildCardSwatches(product);

//       product.isSale = false;
//       product.isSoldOut = product.inStock === false;

//       // Only show secondary hover image when a real second URL exists
//       var mainImage = product.mainImage || "";
//       var hoverImage = product.hoverImage || "";
//       product.hasHoverImage = !!(
//         hoverImage &&
//         hoverImage !== mainImage
//       );
//       product.mainImage = ensureImageWidthJoin(mainImage);
//       if (product.hasHoverImage) {
//         product.hoverImage = ensureImageWidthJoin(hoverImage);
//       }

//       // Client: show whole rupees only (remove .00 / decimals)
//       product.price = stripPriceDecimals(product.price);
//       product.sellingPrice = stripPriceDecimals(product.sellingPrice);
//       product.discount = stripPriceDecimals(product.discount);

//       // by wizzy: Sale badge from compare-at (price) > selling price — same as collection cards
//       var compareAt = parseFloat(
//         String(product.price != null ? product.price : "").replace(/[^\d.]/g, ""),
//         10
//       );
//       var selling = parseFloat(
//         String(product.sellingPrice != null ? product.sellingPrice : "").replace(
//           /[^\d.]/g,
//           ""
//         ),
//         10
//       );
//       if (!isNaN(compareAt) && !isNaN(selling) && compareAt > selling) {
//         product.isSale = true;
//       }

//       if (product.isSoldOut) {
//         product.isSale = false;
//       }
//     });

//     return products;
//   }
// );

// // by wizzy - start: autocomplete product tiles = in-stock only (keep OOS on full search PLP)
// window.wizzyConfig.events.registerEvent(
//   window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
//   function (payload) {
//     if (payload && typeof payload === "object") {
//       payload.includeOutOfStock = "false";
//     }
//     return payload;
//   }
// );

// window.wizzyConfig.events.registerEvent(
//   window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_RENDER,
//   function (data) {
//     try {
//       var products = data && data.payload && data.payload.products;
//       if (products && Array.isArray(products.result)) {
//         products.result = products.result.filter(function (product) {
//           return product && product.inStock !== false;
//         });
//         if (typeof products.total !== "undefined") {
//           products.total = products.result.length;
//         }
//       }
//     } catch (e) {}
//     return data;
//   }
// );
// // by wizzy - end

// window.wizzyConfig.events.registerEvent(
//   window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
//   applyColorFacetSwatches
// );

// // window.wizzyConfig.events.registerEvent(
// //   window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_SUGGESTIONS_RENDER,
// //   function (payload) {
// //     var maxRecentSearches = 5;

// //     try {
// //       var raw = window.localStorage.getItem("wizzy_store");
// //       var stored = raw ? JSON.parse(raw) : null;
// //       if (stored && Array.isArray(stored.SEARCHED_KEYWORDS) && stored.SEARCHED_KEYWORDS.length > maxRecentSearches) {
// //         stored.SEARCHED_KEYWORDS = stored.SEARCHED_KEYWORDS.slice(-maxRecentSearches);
// //         window.localStorage.setItem("wizzy_store", JSON.stringify(stored));
// //       }
// //     } catch (error) {}

// //     if (!payload || !Array.isArray(payload.suggestions)) return payload;

// //     var shown = 0;
// //     payload.suggestions = payload.suggestions.filter(function (item) {
// //       if (!item || !item.isRecentSearch || item.isHead) return true;
// //       shown += 1;
// //       return shown <= maxRecentSearches;
// //     });

// //     return payload;
// //   }
// // );

// function trackMetaSearch(searchString) {
//           var term = String(searchString || "").trim();
//           if (!term) return;

//           function send() {
//               if (typeof fbq === "undefined") return false;
//               fbq("track", "Search", { search_string: term });
//               return true;
//           }

//           if (send()) return;

//           var tries = 0;
//           var timer = setInterval(function () {
//               tries += 1;
//               if (send() || tries >= 20) clearInterval(timer);
//           }, 500);
//       }

// window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED, function(payload) {
//           // if (typeof gtag !== "undefined") {
//           //     gtag('event', 'search', {
//           //         search_term : payload.q
//           //     });
//           // }

//           var collectionHeaderTitle = document.querySelector("#shopify-section-template--23947582079188__collection-header h1");
// if (collectionHeaderTitle) {
//   collectionHeaderTitle.style.display = "none";
// }

//        const pageContent = document.querySelector(
//     '.page-width.page-content.page-content--top'
//   );

//   if (pageContent) {
//     pageContent.style.display = 'none';
//   }

//           trackMetaSearch(payload && payload.q);



//           // if (typeof clarity !== "undefined") {
//           //     window.clarity('event', 'search', {
//           //         search_term : payload.q
//           //     })
//           // }
//           setTimeout(syncAutocompletePosition, 2);

//           return payload;
//       });



//       window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.AFTER_FILTER_ITEM_CLICKED, function(payload) {
//           // if (typeof gtag !== "undefined") {
//           //     gtag('event', 'filters_applied', {
//           //         key : payload.facetKey,
//           //         value: payload.facetLabel, 
//           //     });
//           // }

//           if (typeof fbq !== "undefined") {
//               fbq('track', 'FiltersApplied', {
//                   key : payload.facetKey,
//                   value: payload.facetLabel, 
//               });
//           }

//           // if (typeof clarity !== "undefined") {
//           //     window.clarity('event', 'filters_applied', {
//           //         key : payload.facetKey,
//           //         value: payload.facetLabel,
//           //     });
//           // }
//           return payload;
//       });

// function fixWizzyPaginationExpectedBehavior() {
//   if (window.matchMedia("(max-width: 768px)").matches) return;

//   const pagesBefore = 1;
//   const pagesAfter = 2;

//   const pagination = document.querySelector('.wizzy-search-pagination .wizzy-pagination-list');
//   if (!pagination) return;

//   const activePageEl = pagination.querySelector('li.active[data-page]');
//   const pageEls = Array.from(pagination.querySelectorAll('li[data-page]'));

//   if (!activePageEl || !pageEls.length) return;

//   const activePage = parseInt(activePageEl.dataset.page, 10);
//   const lastPage = Math.max(
//     ...pageEls
//       .map((li) => parseInt(li.dataset.page, 10))
//       .filter(Boolean)
//   );

//   if (!activePage || !lastPage) return;

//   const pages = new Set([1, lastPage]);

//   for (let i = activePage - pagesBefore; i <= activePage + pagesAfter; i++) {
//     if (i >= 1 && i <= lastPage) {
//       pages.add(i);
//     }
//   }

//   const sortedPages = Array.from(pages).sort((a, b) => a - b);

//   const previousArrow = pagination.querySelector('.previous-arrow');
//   const nextArrow = pagination.querySelector('.next-arrow');

//   pagination.querySelectorAll('li:not(.pagination-arrow)').forEach((li) => li.remove());

//   sortedPages.forEach((page, index) => {
//     const previousPage = sortedPages[index - 1];

//     if (index > 0 && page - previousPage > 1) {
//       const dots = document.createElement('li');
//       dots.innerHTML = '<a><span class="text">...</span></a>';
//       pagination.insertBefore(dots, nextArrow);
//     }

//     const li = document.createElement('li');
//     li.setAttribute('title', String(page));
//     li.setAttribute('data-page', String(page));

//     if (page === activePage) {
//       li.classList.add('active');
//     }

//     li.innerHTML = `<a><span class="text">${page}</span></a>`;
//     pagination.insertBefore(li, nextArrow);
//   });
// }

// window.wizzyConfig.events.registerEvent(
//   window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
//   function (products) {
//     afterCardsRendered(products);
//     moveSearchSummaryAboveProducts();
//     fixWizzyPaginationExpectedBehavior();
//     setTimeout(fixWizzyPaginationExpectedBehavior, 300);
//     setTimeout(fixWizzyPaginationExpectedBehavior, 1000);
//     return products;
//   }
// );

// window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_RENDER, function(data) {
//        setTimeout(syncAutocompletePosition, 2);
//       return data;
//   });

// window.wizzyConfig.events.registerEvent(
//   window.wizzyConfig.events.allowedEvents.PRODUCTS_RESULTS_RENDERED,
//   afterCardsRendered
// );

// window.wizzyConfig.events.registerEvent(
//   window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
//   afterCardsRendered
// );


// function useInfiniteScrollOnMobile(data) {
//   if (!window.matchMedia("(max-width: 768px)").matches) return data;

//   var pagination = data && data.search && data.search.configs && data.search.configs.pagination;
//   if (!pagination) return data;

//   pagination.type = "infinite_scroll";
//   pagination.appendInExistingList = true;
//   pagination.infiniteScrollOffset = {
//     desktop: 600,
//     mobile: 800
//   };

//   return data;
// }

//   window.wizzyConfig.events.registerEvent(
// window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
// function (data) {
//     // if (window.innerWidth < 768) {
// data.filters.configs.layout = "v1";
// window.wizzyConfig.filters.configs.layout = "v1";
// data.search.configs.facets.leftFacets.mobileCollapsible = true;
// data.filters.configs.keepOpenedInMobileAfterApply = true;
// useInfiniteScrollOnMobile(data);

//   return data;
// }

// );

// window.wizzyConfig.events.registerEvent(
// window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
// function (data) {
//     // if (window.innerWidth < 768) {
// data.filters.configs.layout = "v1";
// window.wizzyConfig.filters.configs.layout = "v1";
// data.search.configs.facets.leftFacets.mobileCollapsible = true;
// data.filters.configs.keepOpenedInMobileAfterApply = true;
// useInfiniteScrollOnMobile(data);
//   return data;
// }
// );

//   const targetNode = document.querySelector(".wizzy-body-end-wrapper");
// function updateBodyClass() {
//     const autocompleteElement = targetNode.querySelector(".wizzy-autocomplete-wrapper");
//     autocompleteElement && window.getComputedStyle(autocompleteElement).display === "flex" ? document.body.classList.add("wizzy-autocomplete-open") : document.body.classList.remove("wizzy-autocomplete-open")
// }
// const wizzy_observer_config = {
//     childList: !0,
//     subtree: !0,
//     attributes: !0,
//     attributeFilter: ["style"]
// }
//   , callback = function(mutationsList, observer2) {
//     for (const mutation of mutationsList) {
//         updateBodyClass();
//         break
//     }
// }
//   , observer = new MutationObserver(callback);
// targetNode && (observer.observe(targetNode, wizzy_observer_config),
// updateBodyClass());

// };


// function placeCollectionStories() {
//   if (!document.body.classList.contains("template-collection")) return;
//   var stories = document.querySelector(".video-stories");
//   var header = document.querySelector('[data-section-type="collection-header"]');
//   if (!stories || !header) return;
//   var headerSection = header.closest(".shopify-section");
//   if (!headerSection || stories.previousElementSibling === headerSection) return;
//   headerSection.insertAdjacentElement("afterend", stories);
// }

// placeCollectionStories();
// var storyTimer = setInterval(placeCollectionStories, 300);
// setTimeout(function () {
//   clearInterval(storyTimer);
// }, 10000);

// if (window.matchMedia('(min-width: 769px)').matches) {
// document.querySelector('#wz-search-mobile')?.remove();
// }

// function removeDesktopSearchInputOnMobile() {
//   if (window.innerWidth >= 768) return;

//   document.querySelectorAll(".wz-search-box .wz-search-input").forEach(function (input) {
//     if (input.id === "wz-search-mobile") return;
//     input.remove();
//   });
// }

// removeDesktopSearchInputOnMobile();
// window.addEventListener("resize", removeDesktopSearchInputOnMobile);

// function wizzyStoreValue(key) {
//   try {
//     var raw = window.localStorage.getItem("wizzy_store");
//     var data = raw ? JSON.parse(raw) : {};
//     return data[key] || null;
//   } catch (error) {
//     return null;
//   }
// }

// function wizzyPlatformTag() {
//   var os = window.navigator.platform || "";
//   var agent = window.navigator.userAgent || "";
//   if (["Macintosh", "MacIntel", "MacPPC", "Mac68K"].indexOf(os) !== -1) return "Platform:MacOS";
//   if (["iPhone", "iPad", "iPod"].indexOf(os) !== -1) return "Platform:iOS";
//   if (["Win32", "Win64", "Windows", "WinCE"].indexOf(os) !== -1) return "Platform:Windows";
//   if (/Android/.test(agent)) return "Platform:Android";
//   if (/Linux/.test(os)) return "Platform:Linux";
//   return "Platform:Other";
// }

// function wizzyTrackHeaders() {
//   var credentials = window.wizzyConfig && window.wizzyConfig.credentials;
//   if (!credentials || !credentials.apiKey || !credentials.storeId) {
//     // console.log("Wizzy track skipped: missing credentials");
//     return null;
//   }

//   var session = wizzyStoreValue("SESSION_ID");
//   var device = window.matchMedia("(max-width: 768px)").matches ? "Device:Mobile" : "Device:Desktop";

//   return {
//     "x-api-key": credentials.apiKey,
//     "x-store-id": credentials.storeId,
//     "x-request-id": window.crypto.randomUUID(),
//     "x-wizzy-userId": wizzyStoreValue("USER_ID") || "",
//     "x-wizzy-tags": device + "," + wizzyPlatformTag(),
//     "x-wizzy-sessionId": session && session.sessionId ? session.sessionId : ""
//   };
// }

// function trackWizzyAddToCartClick(control) {
//   var card = control.closest(".wizzy-result-product");
//   var headers = wizzyTrackHeaders();
//   var endpoint = (window.wizzyConfig &&
//     window.wizzyConfig.analytics &&
//     window.wizzyConfig.analytics.endpoints &&
//     window.wizzyConfig.analytics.endpoints.clicks) ||
//     "https://shopify-app.wizzy.ai/api/events/track";
//   var cards = Array.prototype.slice.call(document.querySelectorAll(".wizzy-result-product"));
//   var position = card ? cards.indexOf(card) + 1 : 0;
//   var itemId = card ? card.getAttribute("data-product-id") : "";
//   var responseId = window.wizzyConfig &&
//     window.wizzyConfig.pageStore &&
//     window.wizzyConfig.pageStore.lastResponseId;

//   if (!card || !headers || !itemId || position < 1 || !responseId) {
//     // console.log("Wizzy track skipped: missing card, headers, itemId, position, or searchResponseId");
//     return;
//   }

//   var now = Date.now();
//   var trackKey = String(itemId);
//   if (
//     window.__wizzyLastCartTrack &&
//     window.__wizzyLastCartTrack.key === trackKey &&
//     now - window.__wizzyLastCartTrack.at < 2000
//   ) {
//     // console.log("Wizzy track skipped: duplicate click");
//     return;
//   }
//   window.__wizzyLastCartTrack = { key: trackKey, at: now };

//   // console.log("Wizzy add-to-cart track", {
//   //   itemId: itemId,
//   //   position: position,
//   //   searchResponseId: responseId,
//   //   endpoint: endpoint
//   // });

//   fetch(endpoint, {
//     method: "POST",
//     headers: {
//       "Accept": "application/json, text/plain, */*",
//       "Content-Type": "application/json; charset=utf-8",
//       "X-Requested-With": "XMLHttpRequest"
//     },
//     body: JSON.stringify({
//       type: "click",
//       headers: headers,
//       data: {
//         name: "Search Results Clicked",
//         searchResponseId: responseId,
//         items: [{ itemId: String(itemId), position: position }],
//         source: "SEARCH_RESULTS"
//       }
//     })
//   }).then(function (response) {
//     // console.log("Wizzy track response", response.status);
//   }).catch(function (error) {
//     // console.log("Wizzy track failed", error);
//   });
// }

// if (!window.__wizzyCartTrackBound) {
// window.__wizzyCartTrackBound = true;

// document.addEventListener("click", function (event) {
//   var card = event.target.closest(".wizzy-result-product");
//   if (!card) return;

//   var variantChoice = event.target.closest("[data-vid]");
//   if (variantChoice && card.contains(variantChoice)) {
//     // console.log("Wizzy track: metal chosen, product added");
//     trackWizzyAddToCartClick(card);
//     return;
//   }

//   var cartControl = event.target.closest(".wizzy-tocart-button, .satcb_glyphicon-shopping-cart, .satcb_quick_buy .satcb_glyphicon");
//   if (!cartControl || !card.contains(cartControl)) return;

//   if (card.classList.contains("has-variations")) {
//     // console.log("Wizzy track skipped: cart icon only opened Gold/Silver");
//     return;
//   }

//   // console.log("Wizzy track: cart icon added the product");
//   trackWizzyAddToCartClick(card);
// }, true);
// }

function syncAutocompletePosition() {
  if (window.innerWidth < 768) return;

  const searchBar = document.querySelector(
      ".wz-search-box .wz-search-input"
  );

  const autoComplete = document.querySelector(
      ".wizzy-autocomplete-wrapper"
  );

  if (!searchBar || !autoComplete) return;

  const rect = searchBar.getBoundingClientRect();
  const rightOffset = window.innerWidth - rect.right;

  autoComplete.style.setProperty(
      "right",
      `${rightOffset}px`,
      "important"
  );

  autoComplete.style.setProperty(
      "left",
      "auto",
      "important"
  );
}


document.addEventListener("click", function (event) {
  if (
      window.innerWidth >= 768 &&
      event.target.matches(".wz-search-box .wz-search-input")
  ) {
      requestAnimationFrame(function () {
          requestAnimationFrame(syncAutocompletePosition);
      });
  }
});


// document.addEventListener("focusin", function (event) {
//     if (
//         window.innerWidth >= 768 &&
//         event.target.matches(".wz-search-box .wz-search-input")
//     ) {
//         requestAnimationFrame(function () {
//             requestAnimationFrame(syncAutocompletePosition);
//         });
//     }
// });
function syncAutocompletePosition() {
  if (window.innerWidth < 768) return;

  const searchBar = document.querySelector(
      ".wz-search-box .wz-search-input"
  );

  const autoComplete = document.querySelector(
      ".wizzy-autocomplete-wrapper"
  );

  if (!searchBar || !autoComplete) return;

  const rect = searchBar.getBoundingClientRect();
  const rightOffset = window.innerWidth - rect.right;

  autoComplete.style.setProperty(
      "right",
      `${rightOffset}px`,
      "important"
  );

  autoComplete.style.setProperty(
      "left",
      "auto",
      "important"
  );
}


document.addEventListener("click", function (event) {
  if (
      window.innerWidth >= 768 &&
      event.target.matches(".wz-search-box .wz-search-input")
  ) {
      requestAnimationFrame(function () {
          requestAnimationFrame(syncAutocompletePosition);
      });
  }
});


// document.addEventListener("focusin", function (event) {
//     if (
//         window.innerWidth >= 768 &&
//         event.target.matches(".wz-search-box .wz-search-input")
//     ) {
//         requestAnimationFrame(function () {
//             requestAnimationFrame(syncAutocompletePosition);
//         });
//     }
// });
window.onWizzyScriptLoaded = function () {

// Optional fallback only. Prefer Shopify/Wizzy `data.swatch` from the API.
// Override/extend without editing logic:
//   window.wizzyColorSwatchConfig = { "New Color": "#aabbcc" };
var DEFAULT_COLOR_SWATCH_CONFIG = {
  Green: "#008000",
  Silver: "#C0C0C0",
  Red: "#FF0000",
  Gold: "#D4AF37",
  Pink: "#FFC0CB",
  Blue: "#0000FF",
  "Mint Green": "#98FF98",
  MintGreen: "#98FF98",
  Mint: "#98FF98",
  White: "#FFFFFF",
  white: "#FFFFFF",
  Purple: "#800080",
  "Rose Gold": "#B76E79",
  Yellow: "#FFD700",
  Ruby: "#E0115F",
  "Dark Pink": "#C71585",
  "Light Pink": "#FFB6C1",
  "Baby Pink": "#F4C2C2",
  Orange: "#FFA500",
  "Dark Green": "#006400",
  Black: "#000000",
  Champagne: "#F7E7CE",
  Brown: "#8B4513",
  Cyan: "#00FFFF",
  "Deep Red": "#8B0000",
  Fluoride: "#C8F7E8",
  Grey: "#808080",
  Gray: "#808080",
  Pearl: "#F0EAD6",
  Lavender: "#E6E6FA",
  Peach: "#FFCBA4",
  Multicolor:
    "linear-gradient(90deg, #FF0000, #FFA500, #FFD700, #008000, #0000FF, #800080)",
  "Multi-color":
    "linear-gradient(90deg, #FF0000, #FFA500, #FFD700, #008000, #0000FF, #800080)",
  Multi:
    "linear-gradient(90deg, #FF0000, #FFA500, #FFD700, #008000, #0000FF, #800080)",
  Navratna:
    "linear-gradient(90deg, #E0115F, #FFFFFF, #FF0000, #008000, #FFD700, #0000FF, #FF8C00, #800080, #FFC0CB)",
  "Red & Green": "linear-gradient(90deg, #FF0000 50%, #008000 50%)",
  "Green & Red": "linear-gradient(90deg, #008000 50%, #FF0000 50%)",
  "Mint & Pink": "linear-gradient(90deg, #98FF98 50%, #FFC0CB 50%)",
  "Pink & Purple": "linear-gradient(90deg, #FFC0CB 50%, #800080 50%)",
  "Mint & Purple": "linear-gradient(90deg, #98FF98 50%, #800080 50%)",
  "Purple & Green": "linear-gradient(90deg, #800080 50%, #008000 50%)",
  "Purple & Pink": "linear-gradient(90deg, #800080 50%, #FFC0CB 50%)",
  "Green & Mint Green": "linear-gradient(90deg, #008000 50%, #98FF98 50%)",
  "Green & Purple": "linear-gradient(90deg, #008000 50%, #800080 50%)",
  "Green Blue": "linear-gradient(90deg, #008000 50%, #0000FF 50%)",
  "Purple & Mint": "linear-gradient(90deg, #800080 50%, #98FF98 50%)",
  "Blue Purple": "linear-gradient(90deg, #0000FF 50%, #800080 50%)",
  "Blue-Green": "linear-gradient(90deg, #0000FF 50%, #008000 50%)",
  "Blue-Pink": "linear-gradient(90deg, #0000FF 50%, #FFC0CB 50%)",
  "Dual Polish": "linear-gradient(90deg, #D4AF37 50%, #C0C0C0 50%)",
  "Fluorite-Mint": "linear-gradient(90deg, #A7C7E7 50%, #98FF98 50%)"
};

var colorMap = Object.assign(
  {},
  DEFAULT_COLOR_SWATCH_CONFIG,
  window.wizzyColorSwatchConfig || {}
);

// label(lower) → resolved paint value for post-render gradient fixes
var resolvedFacetSwatches = {};

function handleize(value) {
  return String(value || "")
    .toLowerCase()
    .trim()
    .replace(/['"]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

function getProductHandle(product) {
  if (product.handle) return product.handle;

  if (product.attributes && Array.isArray(product.attributes)) {
    for (var i = 0; i < product.attributes.length; i++) {
      var attr = product.attributes[i];
      if (
        attr.id === "product_handle" &&
        attr.values &&
        attr.values.length &&
        attr.values[0].value
      ) {
        return attr.values[0].value[0];
      }
    }
  }

  if (product.url) {
    var match = String(product.url).match(/\/products\/([^/?#]+)/);
    if (match) return match[1];
  }

  return "";
}

function getColorSwatchItems(product) {
  var swatches = product.swatches;
  if (!swatches) return [];

  if (Array.isArray(swatches)) {
    for (var i = 0; i < swatches.length; i++) {
      var group = swatches[i];
      if (!group || !Array.isArray(group.values)) continue;
      var key = String(group.key || "").toLowerCase();
      if (
        key === "colors" ||
        key === "color" ||
        key === "colours" ||
        key === "colour" ||
        group.isPrimary
      ) {
        return group.values;
      }
    }
    if (swatches[0] && Array.isArray(swatches[0].values)) {
      return swatches[0].values;
    }
    return [];
  }

  if (swatches.colors && Array.isArray(swatches.colors.values)) {
    return swatches.colors.values;
  }

  return [];
}

function getSwatchLabel(item) {
  if (!item) return "";
  if (item.label) return String(item.label);
  var value = item.value;
  if (Array.isArray(value)) return String(value[0] || "");
  return String(value || "");
}

function getApiSwatchValue(item) {
  if (!item) return "";

  if (
    item.data &&
    item.data.swatch &&
    item.data.swatch.value != null &&
    String(item.data.swatch.value).trim() !== ""
  ) {
    return String(item.data.swatch.value).trim();
  }

  if (item.swatchValue != null && String(item.swatchValue).trim() !== "") {
    return String(item.swatchValue).trim();
  }

  if (item.swatch && item.swatch.value != null) {
    return String(item.swatch.value).trim();
  }

  // Product card swatch values sometimes carry a direct color/hex field
  if (item.color != null && String(item.color).trim() !== "") {
    return String(item.color).trim();
  }

  return "";
}

function isImageSwatchUrl(value) {
  if (!value) return false;
  if (/^https?:\/\//i.test(value)) return true;
  if (/^\/\//.test(value)) return true;
  return /\.(png|jpe?g|webp|gif|svg)(\?.*)?$/i.test(value);
}

function isUsableSwatchValue(value) {
  if (!value) return false;
  if (/gradient/i.test(value)) return true;
  if (isImageSwatchUrl(value)) return true;
  if (/^#([0-9a-f]{3}|[0-9a-f]{6}|[0-9a-f]{8})$/i.test(value)) return true;
  if (/^rgba?\(/i.test(value)) return true;
  if (/^hsla?\(/i.test(value)) return true;
  return false;
}

function findConfigColorValue(label) {
  if (!label) return "";
  if (colorMap[label]) return colorMap[label];

  var keys = Object.keys(colorMap);
  var lower = String(label).toLowerCase();
  for (var i = 0; i < keys.length; i++) {
    if (keys[i].toLowerCase() === lower) return colorMap[keys[i]];
  }
  return "";
}

/**
 * Resolve paint value for a facet/card color.
 * Priority: API data.swatch → optional config → grey
 */
function resolveSwatchPaint(itemOrLabel, maybeLabel) {
  var item = typeof itemOrLabel === "object" ? itemOrLabel : null;
  var label =
    maybeLabel ||
    (item ? item.key || item.label || getSwatchLabel(item) : itemOrLabel) ||
    "";

  var apiValue = getApiSwatchValue(item);
  if (isUsableSwatchValue(apiValue)) {
    return {
      value: apiValue,
      source: "api",
      isURLSwatch: isImageSwatchUrl(apiValue) && !/gradient/i.test(apiValue)
    };
  }

  var configValue = findConfigColorValue(label);
  if (isUsableSwatchValue(configValue)) {
    return {
      value: configValue,
      source: "config",
      isURLSwatch:
        isImageSwatchUrl(configValue) && !/gradient/i.test(configValue)
    };
  }

  return {
    value: "#e5e5e5",
    source: "fallback",
    isURLSwatch: false
  };
}

function findColorValue(label) {
  var resolved = resolveSwatchPaint(null, label);
  return resolved.source === "fallback" ? "" : resolved.value;
}

function buildSwatchStyleFromValue(color) {
  if (!color) return "background-color:#e5e5e5;";
  if (/gradient/i.test(color)) {
    return "background-image:" + color + ";";
  }
  if (isImageSwatchUrl(color)) {
    var url = color.indexOf("//") === 0 ? "https:" + color : color;
    return "background-image:url(" + url + ");background-size:cover;";
  }
  return "background-color:" + color + ";";
}

function buildSwatchStyle(label, item) {
  var resolved = resolveSwatchPaint(item || null, label);
  return buildSwatchStyleFromValue(resolved.value);
}

function buildCardSwatches(product) {
  var handle = product.handle;
  var items = getColorSwatchItems(product);
  var seen = {};
  var cardSwatches = [];

  items.forEach(function (item) {
    if (!item) return;
    var label = getSwatchLabel(item).trim();
    var variationId = item.variationId;
    if (!label || !variationId) return;

    var uniqueKey = label.toLowerCase();
    if (seen[uniqueKey]) return;
    seen[uniqueKey] = true;

    cardSwatches.push({
      label: label,
      handle: handleize(label),
      variationId: String(variationId),
      href: handle
        ? "/products/" + handle + "?variant=" + variationId
        : "?variant=" + variationId,
      swatchStyle: buildSwatchStyle(label, item)
    });
  });

  product.cardSwatches = cardSwatches;
  product.hasCardSwatches = cardSwatches.length >= 2;
}

var variantImageCache = {};

function normalizeImageUrl(src) {
  if (!src) return "";
  if (src.indexOf("//") === 0) return "https:" + src;
  return src;
}

function getVariantImageMap(handle) {
  if (!handle) return Promise.resolve({});
  if (variantImageCache[handle]) return variantImageCache[handle];

  variantImageCache[handle] = fetch("/products/" + encodeURIComponent(handle) + ".js")
    .then(function (response) {
      if (!response.ok) throw new Error("product json failed");
      return response.json();
    })
    .then(function (data) {
      var map = {};
      var fallback = normalizeImageUrl(data.featured_image || "");
      (data.variants || []).forEach(function (variant) {
        var src = "";
        if (variant.featured_image) {
          src = variant.featured_image.src || variant.featured_image;
        }
        src = normalizeImageUrl(src) || fallback;
        if (src) map[String(variant.id)] = src;
      });
      return map;
    })
    .catch(function () {
      delete variantImageCache[handle];
      return {};
    });

  return variantImageCache[handle];
}

function bindSwatchHover() {
  document.querySelectorAll(".wizzy-result-product").forEach(function (card) {
    if (card.dataset.wizzySwatchHoverBound === "true") return;

    var swatches = card.querySelectorAll(".grid-product__colors .color-swatch");
    if (!swatches.length) return;

    var handle = card.getAttribute("data-product-handle") || "";
    var preview = card.querySelector(".wizzy-swatch-preview");
    if (!handle || !preview) return;

    card.dataset.wizzySwatchHoverBound = "true";
    getVariantImageMap(handle);

    var hoveredId = null;

    function showPreview(swatch) {
      var variantId = swatch.getAttribute("data-variant-id");
      hoveredId = variantId;
      getVariantImageMap(handle).then(function (map) {
        if (hoveredId !== variantId) return;
        var url = map[variantId];
        if (!url) return;
        preview.style.backgroundImage = "url(" + url + ")";
        preview.classList.add("is-active");
        swatch.classList.add("is-active");
      });
    }

    function hidePreview(swatch) {
      hoveredId = null;
      preview.classList.remove("is-active");
      swatch.classList.remove("is-active");
    }

    swatches.forEach(function (swatch) {
      swatch.addEventListener("mouseenter", function () {
        showPreview(swatch);
      });
      swatch.addEventListener("mouseleave", function () {
        hidePreview(swatch);
      });
    });
  });
}

function bindImpulseQuickShop() {
  if (!window.theme || typeof theme.preloadProductModal !== "function") {
    return;
  }

  document.querySelectorAll(".wizzy-result-product").forEach(function (card) {
    if (card.dataset.wizzyQuickShopBound === "true") return;
    card.dataset.wizzyQuickShopBound = "true";

    var handle =
      card.getAttribute("data-product-handle") ||
      card.getAttribute("handle") ||
      "";
    var productId = card.getAttribute("data-product-id") || "";
    var btn = card.querySelector(".quick-product__btn");

    if (!handle || !productId || !btn) return;

    var preloading = false;

    function isReady() {
      return !btn.classList.contains("quick-product__btn--not-ready");
    }

    function preload() {
      if (theme.config && theme.config.bpSmall) return;
      if (preloading || isReady()) return;
      preloading = true;
      theme.preloadProductModal(handle, productId, btn);

      var tries = 0;
      var timer = setInterval(function () {
        tries += 1;
        if (isReady() || tries > 50) {
          clearInterval(timer);
          preloading = false;
        }
      }, 100);
    }

    function productMouseover() {
      card.removeEventListener("mouseover", productMouseover);
      card.removeEventListener("focusin", productMouseover);
      preload();
    }

    card.addEventListener("mouseover", productMouseover);
    card.addEventListener("focusin", productMouseover);

    // Capture phase so we can cancel <a> navigation; do not stopPropagation when
    // ready or Impulse's Modals open listener on this same button never runs.
    btn.addEventListener(
      "click",
      function (e) {
        e.preventDefault();

        if (theme.config && theme.config.bpSmall) return;

        // Already preloaded — let Impulse Modals open handler run
        if (isReady()) return;

        e.stopPropagation();
        preload();

        var tries = 0;
        var timer = setInterval(function () {
          tries += 1;
          if (isReady()) {
            clearInterval(timer);
            btn.dispatchEvent(
              new MouseEvent("click", {
                bubbles: true,
                cancelable: true,
                view: window
              })
            );
          } else if (tries > 50) {
            clearInterval(timer);
          }
        }, 100);
      },
      true
    );
  });
}

  function getAbsoluteProductUrl(product) {
    var url = String(product.url || "");
    if (url.indexOf("http://") === 0 || url.indexOf("https://") === 0) {
      return url;
    }
    if (product.handle) url = "/products/" + product.handle;
    if (!url) return "";
    if (url.charAt(0) !== "/") url = "/" + url;
    return window.location.origin + url;
  }

  function bindWizzySwymDelegate() {
    if (document.body.dataset.wizzySwymDelegate === "true") return;
    document.body.dataset.wizzySwymDelegate = "true";

    document.addEventListener("click", function (e) {
      var btn = e.target.closest(".wizzy-result-product button#swym-collections");
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      var proxy = document.querySelector("[data-wizzy-swym-proxy='true']");
      if (!proxy) return;

      proxy.setAttribute("data-product-url", btn.getAttribute("data-product-url") || "");
      proxy.setAttribute("data-product-id", btn.getAttribute("data-product-id") || "");
      proxy.setAttribute("data-variant-id", btn.getAttribute("data-variant-id") || "");
      proxy.click();
    }, true);
  }

  function ensureSwymClickProxy() {
    if (document.querySelector("[data-wizzy-swym-proxy='true']")) return;
    if (typeof onSwymLoadCallback !== "function") return;

    function createProxy(swat) {
      if (document.querySelector("[data-wizzy-swym-proxy='true']")) return;
      window._swat = window._swat || swat;
      if (!window._swat) return;

      var proxy = document.createElement("button");
      proxy.id = "swym-collections";
      proxy.setAttribute("data-wizzy-swym-proxy", "true");
      proxy.className = "swym-button swym-heart swym-add-to-wishlist-view-product";
      proxy.style.display = "none";
      document.body.appendChild(proxy);

      var closeBtn = document.getElementById("swym-custom-modal-close");
      var addBtn = document.getElementById("swym-custom-add-to-wishlist-button");
      if (closeBtn && closeBtn.parentNode) {
        closeBtn.parentNode.replaceChild(closeBtn.cloneNode(true), closeBtn);
      }
      if (addBtn && addBtn.parentNode) {
        addBtn.parentNode.replaceChild(addBtn.cloneNode(true), addBtn);
      }

      onSwymLoadCallback(window._swat);
    }

    if (window._swat) {
      createProxy(window._swat);
      return;
    }

    window.SwymCallbacks = window.SwymCallbacks || [];
    window.SwymCallbacks.push(createProxy);
  }

  function reinitSwymWishlist() {
    document.querySelectorAll(".wizzy-result-product button#swym-collections").forEach(function (btn) {
      btn.classList.add("swym-custom-loaded");
    });
    bindWizzySwymDelegate();
    ensureSwymClickProxy();
  }

  function moveSearchSummaryAboveProducts() {
    var summary = document.querySelector(".wizzy-search-summary-container");
    var sort = document.querySelector(".wizzy-search-sort-wrapper");
    var filtersTop = document.querySelector(
      ".wizzy-search-results-container > .wizzy-search-filters-top"
    );
    if (!summary || !filtersTop) return;

    var isDesktop = window.matchMedia("(min-width: 769px)").matches;

    if (summary.parentElement !== filtersTop) {
      var valuesWrap = filtersTop.querySelector(".filters-list-top-values-wrapper");
      if (valuesWrap) filtersTop.insertBefore(summary, valuesWrap);
      else filtersTop.appendChild(summary);
    }

    // Sort sits inside the summary row on desktop only
    if (isDesktop && sort && sort.parentElement !== summary) {
      summary.appendChild(sort);
    }
  }

  function sortOptionIdentity(option) {
    if (!option) return "";
    return (
      String(option.value || "").trim() +
      "|" +
      String(option.getAttribute("data-order") || "").trim()
    );
  }

  function configuredDefaultSortIdentity() {
    var sorts =
      window.wizzyConfig &&
      window.wizzyConfig.search &&
      window.wizzyConfig.search.configs &&
      window.wizzyConfig.search.configs.sorts &&
      window.wizzyConfig.search.configs.sorts.configs;
    if (!sorts) return "";
    var keys = Object.keys(sorts);
    if (!keys.length || !sorts[keys[0]] || !sorts[keys[0]].field) return "";
    return (
      String(sorts[keys[0]].field).trim() +
      "|" +
      String(sorts[keys[0]].order || "").trim()
    );
  }

  function isNonDefaultSort() {
    var select = document.querySelector(".wizzy-search-sort-wrapper select");
    if (!select || select.selectedIndex < 0 || !select.options.length) return false;

    var option = select.options[select.selectedIndex];
    if (!option) return false;

    var current = sortOptionIdentity(option);
    var configured = configuredDefaultSortIdentity();
    if (configured) {
      for (var i = 0; i < select.options.length; i++) {
        if (sortOptionIdentity(select.options[i]) === configured) {
          return current !== configured;
        }
      }
    }

    var text = String(option.text || "").trim().toLowerCase();
    if (!text || text === "sort by" || text.indexOf("relevant") !== -1) return false;
    return current !== sortOptionIdentity(select.options[0]);
  }

  function appliedFilterCount() {
    if (!document.querySelector(".wizzy-filters-header .wizzy-filters-clear-all")) {
      return 0;
    }

    var items = document.querySelectorAll(
      ".wizzy-selected-filters .wizzy-selected-facet-list-item"
    );
    var count = 0;
    items.forEach(function (item) {
      if (!item.getAttribute("data-key")) return;
      count += 1;
    });
    return count || items.length;
  }

  function setAppliedDot(host, on) {
    if (!host) return;
    var existing = host.querySelector(":scope > .wz-applied-dot");
    if (!on) {
      if (existing) existing.remove();
      return;
    }
    if (existing) return;
    var dot = document.createElement("span");
    dot.className = "wz-applied-dot";
    dot.setAttribute("aria-hidden", "true");
    host.appendChild(dot);
  }

  function syncMobileFilterSortIndicators() {
    var count = appliedFilterCount();
    var filtersOn = count > 0;
    var sortOn = isNonDefaultSort();

    document.querySelectorAll(".wz-active-filters-mobile-count").forEach(function (el) {
      el.textContent = filtersOn ? "(" + count + ")" : "";
    });

    document.querySelectorAll(".wz-filter-icon > .wz-applied-dot").forEach(function (dot) {
      dot.remove();
    });

    document.querySelectorAll(".wizzy-filters-mobile-entry").forEach(function (btn) {
      btn.classList.toggle("wz-has-active-filters", filtersOn);
      setAppliedDot(btn, filtersOn);
    });

    document.querySelectorAll(".wizzy-search-sort-wrapper").forEach(function (wrap) {
      wrap.classList.toggle("wz-has-active-sort", sortOn);
      setAppliedDot(wrap.querySelector(".wizzy-common-select-label"), sortOn);
    });
  }

  if (!document.documentElement.dataset.wzFilterSortBound) {
    document.documentElement.dataset.wzFilterSortBound = "1";
    document.addEventListener("change", function (event) {
      var target = event.target;
      if (!target || !target.classList || !target.classList.contains("wizzy-sort-select")) return;
      syncMobileFilterSortIndicators();
    });
  }

  function hideShopifySeoProducts() {
    if (!document.body.classList.contains("template-collection")) return;
    if (!document.querySelector(".wizzy-result-product")) return;

    document.querySelectorAll(".wizzy-seo-products").forEach(function (list) {
      list.classList.add("is-replaced");
      list.style.display = "none";
    });
  }

    function bindHoverImageOnDemand() {
    document.querySelectorAll(".wizzy-result-product").forEach(function (card) {
      if (card.dataset.hoverImageBound === "true") return;
      var image = card.querySelector(".wizzy-hover-image");
      if (!image) return;
      card.dataset.hoverImageBound = "true";

      card.addEventListener("mouseenter", function () {
        if (image.getAttribute("src")) return;
        var src = image.getAttribute("data-src");
        if (!src) return;
        var srcset = image.getAttribute("data-srcset");
        if (srcset) image.setAttribute("srcset", srcset);
        image.setAttribute("src", src);
      });
    });
  }

  function afterCardsRendered(data) {
    bindHoverImageOnDemand();
    hideShopifySeoProducts();
    moveSearchSummaryAboveProducts();
    bindSwatchHover();
    applyGradientFacetSwatches();
    bindImpulseQuickShop();
    reinitSwymWishlist();
    syncMobileFilterSortIndicators();
    return data;
  }

var colorFacetKeys = {
  colors: true,
  product_Color: true,
  product_value_tags_color: true
};

function applyColorFacetSwatches(payload) {
  if (!payload || (payload.api !== "search" && payload.api !== "filter")) {
    return payload;
  }

  var facets =
    payload.response &&
    payload.response.payload &&
    payload.response.payload.facets;
  if (!facets || !Array.isArray(facets)) return payload;

  resolvedFacetSwatches = {};

  facets.forEach(function (facet) {
    if (!facet || !colorFacetKeys[facet.key] || !Array.isArray(facet.data)) {
      return;
    }

    facet.data.forEach(function (item) {
      if (!item) return;

      var label = item.key || item.label || "";
      var resolved = resolveSwatchPaint(item, label);
      var color = resolved.value;

      // Gradients are not URLs — keep solid template path, then fix in
      // applyGradientFacetSwatches(). Image URLs use isURLSwatch.
      item.isSwatch = true;
      item.isVisualSwatch = true;
      item.isURLSwatch = !!resolved.isURLSwatch;
      item.swatchValue = color;
      item.data = {
        value: item.key,
        swatch: {
          type: "visual",
          value: color
        }
      };

      if (label) {
        resolvedFacetSwatches[String(label).toLowerCase()] = color;
      }
    });
  });

  return payload;
}

function applySwatchPaint(el, color) {
  if (!el || !color) return;

  if (/gradient/i.test(color)) {
    el.style.backgroundColor = "transparent";
    el.style.backgroundImage = color;
    return;
  }

  if (isImageSwatchUrl(color)) {
    var url = color.indexOf("//") === 0 ? "https:" + color : color;
    el.style.backgroundColor = "transparent";
    el.style.backgroundImage = "url(" + url + ")";
    el.style.backgroundSize = "cover";
    return;
  }

  el.style.backgroundImage = "none";
  el.style.backgroundColor = color;
}

function applyGradientFacetSwatches() {
  var nodes = document.querySelectorAll(
    ".wizzy-facet-list-item.facet-has-swatch, .wizzy-selected-facet-list-item.facet-has-swatch"
  );

  nodes.forEach(function (li) {
    var label = (
      li.getAttribute("data-term") ||
      li.getAttribute("title") ||
      ""
    ).trim();
    if (!label) return;

    var color =
      resolvedFacetSwatches[label.toLowerCase()] ||
      findColorValue(label);
    if (!color) return;

    var swatch = li.querySelector(
      ".wizzy-facet-item-swatch.facet-visual-swatch"
    );
    applySwatchPaint(swatch, color);
  });

  // Fallback: fix invalid inline styles templates may emit for gradients
  document.querySelectorAll(".facet-visual-swatch").forEach(function (el) {
    var styleAttr = el.getAttribute("style") || "";
    var bgImage = el.style.backgroundImage || "";

    var colorGradientMatch = styleAttr.match(
      /background-color\s*:\s*((?:linear|radial)-gradient\([^;]*\))/i
    );
    if (colorGradientMatch) {
      applySwatchPaint(el, colorGradientMatch[1]);
      return;
    }

    if (/url\(\s*['"]?(?:linear|radial)-gradient/i.test(bgImage)) {
      var unwrapped = bgImage.replace(
        /^url\(\s*['"]?((?:linear|radial)-gradient[\s\S]*?)['"]?\s*\)$/i,
        "$1"
      );
      if (unwrapped && unwrapped !== bgImage) {
        applySwatchPaint(el, unwrapped);
      }
    }
  });
}

function stripPriceDecimals(value) {
  if (value === undefined || value === null) return value;
  var str = String(value);
  if (str.indexOf(".") === -1) return str;
  return str.split(".")[0];
}

// So liquid can safely append &width=360 for responsive srcset
function ensureImageWidthJoin(url) {
  if (!url) return "";
  var s = String(url);
  if (s.indexOf("?") === -1) return s + "?";
  return s;
}

window.wizzyConfig.events.registerEvent(
  window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
  function (products) {
    if (!Array.isArray(products)) return products;

    products.forEach(function (product) {
        product.displayAddToCart = true;
        product.handle = getProductHandle(product);
        // Shopify product id (not variant id) — required for Impulse Quick Shop modal
        product.shopifyProductId = String(
          product.groupId || product.singleVarientGroupId || ""
        );
        product.wishlistUrl = getAbsoluteProductUrl(product);
        buildCardSwatches(product);

      product.isSale = false;
      product.isSoldOut = product.inStock === false;

      // Only show secondary hover image when a real second URL exists
      var mainImage = product.mainImage || "";
      var hoverImage = product.hoverImage || "";
      product.hasHoverImage = !!(
        hoverImage &&
        hoverImage !== mainImage
      );
      product.mainImage = ensureImageWidthJoin(mainImage);
      if (product.hasHoverImage) {
        product.hoverImage = ensureImageWidthJoin(hoverImage);
      }

      // Client: show whole rupees only (remove .00 / decimals)
      product.price = stripPriceDecimals(product.price);
      product.sellingPrice = stripPriceDecimals(product.sellingPrice);
      product.discount = stripPriceDecimals(product.discount);

      // by wizzy: Sale badge from compare-at (price) > selling price — same as collection cards
      var compareAt = parseFloat(
        String(product.price != null ? product.price : "").replace(/[^\d.]/g, ""),
        10
      );
      var selling = parseFloat(
        String(product.sellingPrice != null ? product.sellingPrice : "").replace(
          /[^\d.]/g,
          ""
        ),
        10
      );
      if (!isNaN(compareAt) && !isNaN(selling) && compareAt > selling) {
        product.isSale = true;
      }

      if (product.isSoldOut) {
        product.isSale = false;
      }
    });

    return products;
  }
);

// by wizzy - start: autocomplete product tiles = in-stock only (keep OOS on full search PLP)
window.wizzyConfig.events.registerEvent(
  window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
  function (payload) {
    if (payload && typeof payload === "object") {
      payload.includeOutOfStock = "false";
    }
    return payload;
  }
);

window.wizzyConfig.events.registerEvent(
  window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_RENDER,
  function (data) {
    try {
      var products = data && data.payload && data.payload.products;
      if (products && Array.isArray(products.result)) {
        products.result = products.result.filter(function (product) {
          return product && product.inStock !== false;
        });
        if (typeof products.total !== "undefined") {
          products.total = products.result.length;
        }
      }
    } catch (e) {}
    return data;
  }
);
// by wizzy - end

window.wizzyConfig.events.registerEvent(
  window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
  applyColorFacetSwatches
);



function trackMetaSearch(searchString) {
          var term = String(searchString || "").trim();
          if (!term) return;

          function send() {
              if (typeof fbq === "undefined") return false;
              fbq("track", "Search", { search_string: term });
              return true;
          }

          if (send()) return;

          var tries = 0;
          var timer = setInterval(function () {
              tries += 1;
              if (send() || tries >= 20) clearInterval(timer);
          }, 500);
      }

window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED, function(payload) {
          // if (typeof gtag !== "undefined") {
          //     gtag('event', 'search', {
          //         search_term : payload.q
          //     });
          // }

          var collectionHeaderTitle = document.querySelector("#shopify-section-template--23947582079188__collection-header h1");
if (collectionHeaderTitle) {
  collectionHeaderTitle.style.display = "none";
}

       const pageContent = document.querySelector(
    '.page-width.page-content.page-content--top'
  );

  if (pageContent) {
    pageContent.style.display = 'none';
  }

          trackMetaSearch(payload && payload.q);



          // if (typeof clarity !== "undefined") {
          //     window.clarity('event', 'search', {
          //         search_term : payload.q
          //     })
          // }
          setTimeout(syncAutocompletePosition, 2);

          return payload;
      });



      window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.AFTER_FILTER_ITEM_CLICKED, function(payload) {
          // if (typeof gtag !== "undefined") {
          //     gtag('event', 'filters_applied', {
          //         key : payload.facetKey,
          //         value: payload.facetLabel, 
          //     });
          // }

          if (typeof fbq !== "undefined") {
              fbq('track', 'FiltersApplied', {
                  key : payload.facetKey,
                  value: payload.facetLabel, 
              });
          }

          // if (typeof clarity !== "undefined") {
          //     window.clarity('event', 'filters_applied', {
          //         key : payload.facetKey,
          //         value: payload.facetLabel,
          //     });
          // }
          return payload;
      });

function fixWizzyPaginationExpectedBehavior() {
  if (window.matchMedia("(max-width: 768px)").matches) return;

  const pagesBefore = 1;
  const pagesAfter = 2;

  const pagination = document.querySelector('.wizzy-search-pagination .wizzy-pagination-list');
  if (!pagination) return;

  const activePageEl = pagination.querySelector('li.active[data-page]');
  const pageEls = Array.from(pagination.querySelectorAll('li[data-page]'));

  if (!activePageEl || !pageEls.length) return;

  const activePage = parseInt(activePageEl.dataset.page, 10);
  const lastPage = Math.max(
    ...pageEls
      .map((li) => parseInt(li.dataset.page, 10))
      .filter(Boolean)
  );

  if (!activePage || !lastPage) return;

  const pages = new Set([1, lastPage]);

  for (let i = activePage - pagesBefore; i <= activePage + pagesAfter; i++) {
    if (i >= 1 && i <= lastPage) {
      pages.add(i);
    }
  }

  const sortedPages = Array.from(pages).sort((a, b) => a - b);

  const previousArrow = pagination.querySelector('.previous-arrow');
  const nextArrow = pagination.querySelector('.next-arrow');

  pagination.querySelectorAll('li:not(.pagination-arrow)').forEach((li) => li.remove());

  sortedPages.forEach((page, index) => {
    const previousPage = sortedPages[index - 1];

    if (index > 0 && page - previousPage > 1) {
      const dots = document.createElement('li');
      dots.innerHTML = '<a><span class="text">...</span></a>';
      pagination.insertBefore(dots, nextArrow);
    }

    const li = document.createElement('li');
    li.setAttribute('title', String(page));
    li.setAttribute('data-page', String(page));

    if (page === activePage) {
      li.classList.add('active');
    }

    li.innerHTML = `<a><span class="text">${page}</span></a>`;
    pagination.insertBefore(li, nextArrow);
  });
}

window.wizzyConfig.events.registerEvent(
  window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
  function (products) {
    afterCardsRendered(products);
    moveSearchSummaryAboveProducts();
    fixWizzyPaginationExpectedBehavior();
    setTimeout(fixWizzyPaginationExpectedBehavior, 300);
    setTimeout(fixWizzyPaginationExpectedBehavior, 1000);
    return products;
  }
);

window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_RENDER, function(data) {
       setTimeout(syncAutocompletePosition, 2);
      return data;
  });

    window.wizzyConfig.events.registerEvent(
  window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_SUGGESTIONS_RENDER,
  function (payload) {
    var maxRecentSearches = 5;

    try {
      var raw = window.localStorage.getItem("wizzy_store");
      var stored = raw ? JSON.parse(raw) : null;
      if (stored && Array.isArray(stored.SEARCHED_KEYWORDS) && stored.SEARCHED_KEYWORDS.length > maxRecentSearches) {
        stored.SEARCHED_KEYWORDS = stored.SEARCHED_KEYWORDS.slice(-maxRecentSearches);
        window.localStorage.setItem("wizzy_store", JSON.stringify(stored));
      }
    } catch (error) {}

    if (!payload || !Array.isArray(payload.suggestions)) return payload;

    var shown = 0;
    payload.suggestions = payload.suggestions.filter(function (item) {
      if (!item || !item.isRecentSearch || item.isHead) return true;
      shown += 1;
      return shown <= maxRecentSearches;
    });

    return payload;
  }
);

window.wizzyConfig.events.registerEvent(
  window.wizzyConfig.events.allowedEvents.PRODUCTS_RESULTS_RENDERED,
  afterCardsRendered
);

window.wizzyConfig.events.registerEvent(
  window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
  afterCardsRendered
);


// function useInfiniteScrollOnMobile(data) {
//   if (!window.matchMedia("(max-width: 768px)").matches) return data;

//   var pagination = data && data.search && data.search.configs && data.search.configs.pagination;
//   if (!pagination) return data;

//   pagination.type = "infinite_scroll";
//   pagination.appendInExistingList = true;
//   pagination.infiniteScrollOffset = {
//     desktop: 600,
//     mobile: 800
//   };

//   return data;
// }

  window.wizzyConfig.events.registerEvent(
window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
function (data) {
    // if (window.innerWidth < 768) {
data.filters.configs.layout = "v1";
window.wizzyConfig.filters.configs.layout = "v1";
data.search.configs.facets.leftFacets.mobileCollapsible = true;
data.filters.configs.keepOpenedInMobileAfterApply = true;
// useInfiniteScrollOnMobile(data);

  return data;
}

);

window.wizzyConfig.events.registerEvent(
window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
function (data) {
    // if (window.innerWidth < 768) {
data.filters.configs.layout = "v1";
window.wizzyConfig.filters.configs.layout = "v1";
data.search.configs.facets.leftFacets.mobileCollapsible = true;
data.filters.configs.keepOpenedInMobileAfterApply = true;
// useInfiniteScrollOnMobile(data);
  return data;
}
);

  const targetNode = document.querySelector(".wizzy-body-end-wrapper");
function updateBodyClass() {
    const autocompleteElement = targetNode.querySelector(".wizzy-autocomplete-wrapper");
    autocompleteElement && window.getComputedStyle(autocompleteElement).display === "flex" ? document.body.classList.add("wizzy-autocomplete-open") : document.body.classList.remove("wizzy-autocomplete-open")
}
const wizzy_observer_config = {
    childList: !0,
    subtree: !0,
    attributes: !0,
    attributeFilter: ["style"]
}
  , callback = function(mutationsList, observer2) {
    for (const mutation of mutationsList) {
        updateBodyClass();
        break
    }
}
  , observer = new MutationObserver(callback);
targetNode && (observer.observe(targetNode, wizzy_observer_config),
updateBodyClass());

};


function placeCollectionStories() {
  if (!document.body.classList.contains("template-collection")) return;
  var stories = document.querySelector(".video-stories");
  var header = document.querySelector('[data-section-type="collection-header"]');
  if (!stories || !header) return;
  var headerSection = header.closest(".shopify-section");
  if (!headerSection || stories.previousElementSibling === headerSection) return;
  headerSection.insertAdjacentElement("afterend", stories);
}

placeCollectionStories();
var storyTimer = setInterval(placeCollectionStories, 300);
setTimeout(function () {
  clearInterval(storyTimer);
}, 10000);

if (window.matchMedia('(min-width: 769px)').matches) {
document.querySelector('#wz-search-mobile')?.remove();
}

function removeDesktopSearchInputOnMobile() {
  if (window.innerWidth >= 768) return;

  document.querySelectorAll(".wz-search-box .wz-search-input").forEach(function (input) {
    if (input.id === "wz-search-mobile") return;
    input.remove();
  });
}

removeDesktopSearchInputOnMobile();
window.addEventListener("resize", removeDesktopSearchInputOnMobile);

function wizzyStoreValue(key) {
  try {
    var raw = window.localStorage.getItem("wizzy_store");
    var data = raw ? JSON.parse(raw) : {};
    return data[key] || null;
  } catch (error) {
    return null;
  }
}

function wizzyPlatformTag() {
  var os = window.navigator.platform || "";
  var agent = window.navigator.userAgent || "";
  if (["Macintosh", "MacIntel", "MacPPC", "Mac68K"].indexOf(os) !== -1) return "Platform:MacOS";
  if (["iPhone", "iPad", "iPod"].indexOf(os) !== -1) return "Platform:iOS";
  if (["Win32", "Win64", "Windows", "WinCE"].indexOf(os) !== -1) return "Platform:Windows";
  if (/Android/.test(agent)) return "Platform:Android";
  if (/Linux/.test(os)) return "Platform:Linux";
  return "Platform:Other";
}

function wizzyTrackHeaders() {
  var credentials = window.wizzyConfig && window.wizzyConfig.credentials;
  if (!credentials || !credentials.apiKey || !credentials.storeId) {
    // console.log("Wizzy track skipped: missing credentials");
    return null;
  }

  var session = wizzyStoreValue("SESSION_ID");
  var device = window.matchMedia("(max-width: 768px)").matches ? "Device:Mobile" : "Device:Desktop";

  return {
    "x-api-key": credentials.apiKey,
    "x-store-id": credentials.storeId,
    "x-request-id": window.crypto.randomUUID(),
    "x-wizzy-userId": wizzyStoreValue("USER_ID") || "",
    "x-wizzy-tags": device + "," + wizzyPlatformTag(),
    "x-wizzy-sessionId": session && session.sessionId ? session.sessionId : ""
  };
}

function trackWizzyAddToCartClick(control) {
  var card = control.closest(".wizzy-result-product");
  var headers = wizzyTrackHeaders();
  var endpoint = (window.wizzyConfig &&
    window.wizzyConfig.analytics &&
    window.wizzyConfig.analytics.endpoints &&
    window.wizzyConfig.analytics.endpoints.clicks) ||
    "https://shopify-app.wizzy.ai/api/events/track";
  var cards = Array.prototype.slice.call(document.querySelectorAll(".wizzy-result-product"));
  var position = card ? cards.indexOf(card) + 1 : 0;
  var itemId = card ? card.getAttribute("data-product-id") : "";
  var responseId = window.wizzyConfig &&
    window.wizzyConfig.pageStore &&
    window.wizzyConfig.pageStore.lastResponseId;

  if (!card || !headers || !itemId || position < 1 || !responseId) {
    // console.log("Wizzy track skipped: missing card, headers, itemId, position, or searchResponseId");
    return;
  }

  var now = Date.now();
  var trackKey = String(itemId);
  if (
    window.__wizzyLastCartTrack &&
    window.__wizzyLastCartTrack.key === trackKey &&
    now - window.__wizzyLastCartTrack.at < 2000
  ) {

    // console.log("Wizzy track skipped: duplicate click");
    return;
  }
  window.__wizzyLastCartTrack = { key: trackKey, at: now };

  // console.log("Wizzy add-to-cart track", {
  //   itemId: itemId,
  //   position: position,
  //   searchResponseId: responseId,
  //   endpoint: endpoint
  // });

  fetch(endpoint, {
    method: "POST",
    headers: {
      "Accept": "application/json, text/plain, */*",
      "Content-Type": "application/json; charset=utf-8",
      "X-Requested-With": "XMLHttpRequest"
    },
    body: JSON.stringify({
      type: "click",
      headers: headers,
      data: {
        name: "Search Results Clicked",
        searchResponseId: responseId,
        items: [{ itemId: String(itemId), position: position }],
        source: "SEARCH_RESULTS"
      }
    })
  }).then(function (response) {
    // console.log("Wizzy track response", response.status);
  }).catch(function (error) {
    // console.log("Wizzy track failed", error);
  });
}

if (!window.__wizzyCartTrackBound) {
window.__wizzyCartTrackBound = true;

document.addEventListener("click", function (event) {
  var card = event.target.closest(".wizzy-result-product");
  if (!card) return;

  var variantChoice = event.target.closest("[data-vid]");
  if (variantChoice && card.contains(variantChoice)) {
    // console.log("Wizzy track: metal chosen, product added");
    trackWizzyAddToCartClick(card);
    return;
  }

  var cartControl = event.target.closest(".wizzy-tocart-button, .satcb_glyphicon-shopping-cart, .satcb_quick_buy .satcb_glyphicon");
  if (!cartControl || !card.contains(cartControl)) return;

  if (card.classList.contains("has-variations")) {
    // console.log("Wizzy track skipped: cart icon only opened Gold/Silver");
    return;
  }

  // console.log("Wizzy track: cart icon added the product");
  trackWizzyAddToCartClick(card);
}, true);
}